// Auth header for the console APIs (console-data, agent-copilot,
// agent-wrapup, and outbound-context) — D11-c, 2026-09-09.
//
// The credential is the Cognito ID token from the console login
// (src/auth/cognito.js). API Gateway verifies it with a JWT authorizer before
// the Lambda runs; the Lambda then checks the requested tenant against the
// caller's "tenant:<id>" groups. This replaces the D11 shared-secret header
// that used to be baked into this bundle — nothing secret ships here now.
//
// apiHeaders() is async because the token may need refreshing first.
import { getIdToken } from '../auth/cognito';

export async function apiHeaders(extra = {}) {
  const token = await getIdToken();
  if (!token) return { ...extra };
  return { ...extra, Authorization: `Bearer ${token}` };
}
